export const CORE = "/_oncall/core";
export const AGENT = "/_oncall/agent";
export const AGENT_INSTANCE = "green-basket--next-demo-consumer";

export type AgentChannel = "chat" | "whatsapp";

export type PendingAction = {
  id: string;
  reason?: string;
  capabilityId?: string;
  status: "pending" | "executed" | "cancelled";
};

export async function apiRequest<T = Record<string, unknown>>(
  base: string,
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const response = await fetch(base + path, {
    credentials: "include",
    ...init,
    headers: {
      "content-type": "application/json",
      "x-request-id": crypto.randomUUID(),
      ...(init.headers || {}),
    },
  });
  const body = (await response.json().catch(() => ({}))) as T & {
    detail?: string;
    error?: string;
  };
  if (!response.ok) {
    throw new Error(
      body.detail || body.error || `Request failed (${response.status})`,
    );
  }
  return body;
}

export function messageText(message: {
  parts?: Array<{ type?: string; text?: string }>;
}): string {
  if (!Array.isArray(message.parts)) return "";
  return message.parts
    .map((part) => (part.type === "text" && part.text ? part.text : ""))
    .join("")
    .trim();
}

export function linkifyText(value: string): Array<string | { url: string }> {
  const pattern = /https:\/\/[^\s<>"']+/g;
  const parts: Array<string | { url: string }> = [];
  let offset = 0;
  for (const match of value.matchAll(pattern)) {
    const index = match.index ?? 0;
    const url = match[0];
    if (index > offset) parts.push(value.slice(offset, index));
    parts.push({ url });
    offset = index + url.length;
  }
  if (offset < value.length) parts.push(value.slice(offset));
  return parts;
}
